import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import React, { useEffect, useState } from 'react';
import { QuestionTheme } from '../../styles/mfsTheme';
import { RaterStyles } from '../../styles/rater';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Rater } from '../../interfaces/Rater';
import {
  List,
  ListItem,
  Grid,
  ListItemText,
  Typography,
  ListItemSecondaryAction,
  Button,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { RaterField } from './SearchRaterForm';

export const SearchRaterCard = (props: { rater: Rater; onAddClick: Function }): JSX.Element => {
  const classes = RaterStyles(QuestionTheme);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [fieldNames, setFieldsNames] = useState({
    pId: '',
    function: '',
    country: '',
    region: '',
    level: '',
  });
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const { t } = useTranslation();
  const rater = props.rater;

  useEffect(() => {
    try {
      const fields = sessionStorage.getItem('searchFields');
      const searchFields: RaterField[] = JSON.parse(fields ? fields : '{"fields":[]}').fields;
      fieldNames.pId === '' &&
        setFieldsNames({
          pId: searchFields.filter((option) => option.sequence === 5)[0]?.label,
          function: searchFields.filter((option) => option.sequence === 8)[0]?.label,
          country: searchFields.filter((option) => option.sequence === 6)[0]?.label,
          region: searchFields.filter((option) => option.sequence === 7)[0]?.label,
          level: searchFields.filter((option) => option.sequence === 9)[0]?.label,
        });
    } catch (e) {
      console.error(e);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card variant="outlined" className={classes.raterCard}>
      <CardContent className={classes.raterCardContent}>
        <List disablePadding role="listitem">
          <ListItem role="presentation">
            <Grid container spacing={smUp ? 3 : 0}>
              <Grid item sm={5}>
                <ListItemText
                  secondary={
                    <>
                      <Typography
                        variant="body1"
                        className={clsx(classes.textAlignLeft, classes.raterCardSubTitle)}
                        aria-label={rater.email}>
                        {rater.email}
                      </Typography>
                      {isOpen && smUp ? (
                        <div className={classes.marginTop1}>
                          {rater.personalNumber && (
                            <Typography variant="body1" className={classes.raterCardSubTitle} aria-label={rater.region}>
                              <strong>{fieldNames.pId}:</strong> {rater.personalNumber}
                            </Typography>
                          )}
                          {rater.function && (
                            <Typography
                              variant="body1"
                              className={classes.raterCardSubTitle}
                              aria-label={rater.function.toString()}>
                              <strong>{fieldNames.function}:</strong> {rater.function}
                            </Typography>
                          )}
                          {rater.country && (
                            <Typography
                              variant="body1"
                              className={classes.raterCardSubTitle}
                              aria-label={rater.country}>
                              <strong>{fieldNames.country}:</strong> {rater.country}
                            </Typography>
                          )}
                          {rater.region && (
                            <Typography variant="body1" className={classes.raterCardSubTitle} aria-label={rater.region}>
                              <strong>{fieldNames.region}:</strong> {rater.region}
                            </Typography>
                          )}
                          {rater.level && (
                            <Typography variant="body1" className={classes.raterCardSubTitle} aria-label={rater.region}>
                              <strong>{fieldNames.level}:</strong> {rater.level}
                            </Typography>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                      {!smUp && (
                        <>
                          {!isOpen ? (
                            <div>
                              {rater.function && (
                                <Typography
                                  variant="body1"
                                  className={classes.raterCardSubTitle}
                                  aria-label={rater.function.toString()}>
                                  {rater.function}
                                </Typography>
                              )}

                              {rater.country && (
                                <Typography
                                  variant="body1"
                                  className={classes.raterCardSubTitle}
                                  aria-label={rater.country}>
                                  {rater.country}
                                </Typography>
                              )}
                            </div>
                          ) : (
                            <div className={classes.marginTop1}>
                              {rater.personalNumber && (
                                <Typography
                                  variant="body1"
                                  className={`${classes.raterCardSubTitle} ${classes.raterCardSmWidth100}`}
                                  aria-label={rater.region}>
                                  <strong>{fieldNames.pId}:</strong> {rater.personalNumber}
                                </Typography>
                              )}
                              {rater.fuction && (
                                <Typography
                                  variant="body1"
                                  className={`${classes.raterCardSubTitle} ${classes.raterCardSmWidth100}`}
                                  aria-label={rater.fuction.toString()}>
                                  <strong>{fieldNames.function}:</strong> {rater.fuction}
                                </Typography>
                              )}
                              {rater.country && (
                                <Typography
                                  variant="body1"
                                  className={`${classes.raterCardSubTitle} ${classes.raterCardSmWidth100}`}
                                  aria-label={rater.country}>
                                  <strong>{fieldNames.country}:</strong> {rater.country}
                                </Typography>
                              )}
                              {rater.region && (
                                <Typography
                                  variant="body1"
                                  className={`${classes.raterCardSubTitle} ${classes.raterCardSmWidth100}`}
                                  aria-label={rater.region}>
                                  <strong>{fieldNames.region}:</strong> {rater.region}
                                </Typography>
                              )}
                              {rater.level && (
                                <Typography
                                  variant="body1"
                                  className={`${classes.raterCardSubTitle} ${classes.raterCardSmWidth100}`}
                                  aria-label={rater.level}>
                                  <strong>{fieldNames.level}:</strong> {rater.level}
                                </Typography>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  }>
                  <Typography
                    variant="h6"
                    component="h4"
                    className={clsx(classes.textAlignLeft, classes.raterCardTitle)}
                    aria-label={`${rater.firstName} ${rater.lastName}`}>
                    {`${rater.firstName} ${rater.lastName}`}
                  </Typography>
                </ListItemText>
              </Grid>
              {smUp && !isOpen ? (
                <Grid item sm={5}>
                  <ListItemText>
                    {rater.function && (
                      <Typography
                        variant="body1"
                        className={classes.raterCardSubTitle}
                        aria-label={rater.function.toString()}>
                        {rater.function}
                      </Typography>
                    )}

                    {rater.country && (
                      <Typography variant="body1" className={classes.raterCardSubTitle} aria-label={rater.country}>
                        {rater.country}
                      </Typography>
                    )}
                  </ListItemText>
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
            <ListItemSecondaryAction style={isOpen ? { top: '35px' } : {}}>
              <Button
                variant="contained"
                className={classes.addButton}
                onClick={props.onAddClick(rater)}
                aria-label={`${t('add')} ${rater.firstName} ${rater.lastName}`}>
                {t('add')}
              </Button>

              <IconButton className={classes.expandicon} onClick={(): void => setIsOpen(!isOpen)}>
                <KeyboardArrowDownIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
};
